import { View, Text, Image, TouchableOpacity, Platform } from "react-native";
import React from "react";
import { FlatList } from "react-native-gesture-handler";
import { femaleColor, gray, maleColor, shadowSm, white } from "../../colors";
import MyText from "./MyText";
import { babyBoy, babyGirl } from "../../imports";
import { AntDesign } from "@expo/vector-icons";
import translate from "../../functions/translate";
import { useNavigation } from "@react-navigation/native";
import { useEffect } from "react";
import { useState } from "react";
import childrenList from "../../api/get/childrenList";
import childConsultationStatus from "../../api/consultation/childConsultationStatus";
import { useSelector } from "react-redux";

const showChildOrder = (number, language) => {
  if (language === "fa") {
    switch (number) {
      case 1:
        return "اول";
      case 2:
        return "دوم";
      case 3:
        return "سوم";
      case 4:
        return "چهارم";
      case 5:
        return "پنجم";
      case 6:
        return "ششم";
      case 7:
        return "هفتم";
      case 8:
        return "هشتم";
      case 9:
        return "نهم";
      case 10:
        return "دهم";
      default:
        return "";
    }
  }
};

const Child = (props) => {
  const navigation = useNavigation();
  return (
    <View
      style={{
        ...shadowSm,
        marginHorizontal: 5,
        marginTop: 5,
        padding: 0,
        width: 120,
        height: 160,
      }}
    >
      <TouchableOpacity
        onPress={() => {
          navigation.navigate("EditChild", {
            id: props.id,
            gender: props.gender,
          });
        }}
        style={{
          alignItems: "center",
          width: 120,
          height: 160,
          paddingTop: 5,
          paddingBottom: 0,
          overflow: "hidden",
        }}
      >
        <View>
          <Image
            defaultSource={props.gender === "male" ? babyBoy : babyGirl}
            source={{ uri: props.image }}
            style={{ width: 80, height: 80, marginVertical: 5 }}
            resizeMode="contain"
          />
        </View>

        <View style={{ flex: 1 }}></View>
        <MyText>{props.name}</MyText>
        <View style={{ flex: 1 }}></View>
        <View
          style={{
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
            backgroundColor: props.gender === "male" ? maleColor : femaleColor,
            padding: 5,
            width: "100%",
            alignItems: "center",
            height: 35,
          }}
        >
          <MyText style={{ color: white, fontSize: 12 }}>{`${translate(
            "edit"
          )}`}</MyText>
        </View>
      </TouchableOpacity>
    </View>
  );
};
const AddChild = () => {
  const navigation = useNavigation();
  return (
    <View style={{ ...shadowSm, marginHorizontal: 5, marginTop: 5 }}>
      <TouchableOpacity
        onPress={() => {
          navigation.navigate("NewChildGenderChoose");
        }}
        style={{
          alignItems: "center",
          justifyContent: "center",
          width: 120,
          height: 160,
          paddingTop: 5,
          paddingBottom: 0,
          overflow: "hidden",
        }}
      >
        <View style={{ marginVertical: 5 }}>
          <AntDesign name="plus" size={24} color={gray} />
        </View>
        <View style={{ marginVertical: 5 }}>
          <MyText style={{ color: gray }}>{translate("add children")}</MyText>
        </View>
      </TouchableOpacity>
    </View>
  );
};
export default function SelectChildDetailSlider(props) {
  const main = useSelector((store) => store.main);
  const navigation = useNavigation();
  const [children, setChildren] = useState([]);
  useEffect(() => {
    if (props.isFocused) {
      childrenList()
        .then(({ data }) => {
          if (data.status === 200) {
            setChildren(data.data);
          }
        })
        .catch((err) => {});
    }
  }, [main.refresh, props.isFocused]);
  return (
    <View style={{ width: "100%" }}>
      <FlatList
        style={{ height: 170 }}
        horizontal
        inverted={Platform.OS === "android" && main.rtl ? true : false}
        showsHorizontalScrollIndicator={false}
        ListFooterComponent={Platform.OS === "android" ? null : <AddChild />}
        ListHeaderComponent={Platform.OS === "android" ? <AddChild /> : null}
        data={children}
        renderItem={({ item }) => (
          <Child
            id={item.id}
            image={item.picURL}
            name={item.name}
            gender={item.gender === "boy" ? "male" : "female"}
            childNo={item.chlidrenNO}
            haveChat={item.listCounseling.length > 0}
            chatId={
              item.listCounseling.length > 0
                ? item.listCounseling[0].counselingId
                : null
            }
          />
        )}
      />
    </View>
  );
}
